(function(){
  function initCalendars(){
    document.querySelectorAll('.anchor-event-calendar').forEach(function(cal){
      if(cal.dataset.anchorEventsBound){ return; }
      cal.dataset.anchorEventsBound = '1';
      cal.addEventListener('click', function(e){
        var btn = e.target.closest('.anchor-event-calendar-btn');
        if(!btn || !btn.dataset.month){ return; }
        e.preventDefault();
        var month = btn.dataset.month;
        var showPast = cal.getAttribute('data-show-past') || 'yes';
        fetchCalendar(cal, month, showPast);
      });
      cal.addEventListener('mouseover', handleTooltipOver, true);
      cal.addEventListener('mouseout', handleTooltipOut, true);
      cal.addEventListener('mousemove', handleTooltipMove, true);
    });
  }

  // RENDER-D25: fetchCalendar() used to treat every non-success response (and
  // every network error) as a silent no-op — no message, no console signal.
  // Ajax_calendar()'s check_ajax_referer() dies with body "-1" on a stale
  // nonce (e.g. a page served from an edge cache past the nonce lifetime),
  // which r.json() happily parses as a valid JSON number, so !res.success is
  // true and clicking the month arrows did nothing at all, forever, with no
  // indication why. showCalendarError() surfaces that instead, in an
  // aria-live region so it reaches assistive tech too.
  function showCalendarError(cal, message){
    var status = cal.querySelector('.anchor-event-calendar-status');
    if(!status){
      status = document.createElement('div');
      status.className = 'anchor-event-calendar-status';
      status.setAttribute('role', 'status');
      status.setAttribute('aria-live', 'polite');
      var header = cal.querySelector('.anchor-event-calendar-header');
      if(header && header.parentNode){
        header.parentNode.insertBefore(status, header.nextSibling);
      } else {
        cal.insertBefore(status, cal.firstChild);
      }
    }
    status.textContent = message;
  }

  var CALENDAR_ERROR_MESSAGE = 'Could not load this month. Please try again.';

  function fetchCalendar(cal, month, showPast){
    if(!window.ANCHOR_EVENTS_AJAX || !ANCHOR_EVENTS_AJAX.ajaxUrl){ return; }
    var form = new FormData();
    form.append('action', 'anchor_events_calendar');
    form.append('nonce', ANCHOR_EVENTS_AJAX.nonce || '');
    form.append('month', month || '');
    form.append('show_past', showPast || 'yes');

    cal.classList.add('is-loading');

    fetch(ANCHOR_EVENTS_AJAX.ajaxUrl, { method:'POST', body:form })
      .then(function(r){ return r.json(); })
      .then(function(res){
        cal.classList.remove('is-loading');
        if(!res || !res.success || !res.data || !res.data.html){
          showCalendarError(cal, CALENDAR_ERROR_MESSAGE);
          return;
        }
        var tmp = document.createElement('div');
        tmp.innerHTML = res.data.html;
        var newCal = tmp.querySelector('.anchor-event-calendar');
        if(newCal){
          cal.replaceWith(newCal);
          initCalendars();
        }
      })
      .catch(function(){
        cal.classList.remove('is-loading');
        showCalendarError(cal, CALENDAR_ERROR_MESSAGE);
      });
  }

  function initGalleries(){
    document.querySelectorAll('.anchor-event-gallery').forEach(function(gallery){
      if(gallery.dataset.anchorGalleryBound){ return; }
      gallery.dataset.anchorGalleryBound = '1';
      var track = gallery.querySelector('.anchor-event-gallery-track');
      var prev = gallery.querySelector('.anchor-event-gallery-prev');
      var next = gallery.querySelector('.anchor-event-gallery-next');
      if(!track){ return; }

      function updateNav(){
        var atStart = track.scrollLeft <= 4;
        var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
        var overflowing = track.scrollWidth > track.clientWidth + 4;
        if(prev){ prev.hidden = !overflowing || atStart; }
        if(next){ next.hidden = !overflowing || atEnd; }
      }

      function step(dir){
        var slide = track.querySelector('.anchor-event-gallery-slide');
        var amount = slide ? slide.getBoundingClientRect().width + 12 : track.clientWidth * 0.8;
        track.scrollBy({ left: dir * amount, behavior: 'smooth' });
      }

      if(prev){ prev.addEventListener('click', function(){ step(-1); }); }
      if(next){ next.addEventListener('click', function(){ step(1); }); }
      track.addEventListener('scroll', updateNav, { passive: true });
      window.addEventListener('resize', updateNav);
      updateNav();
    });
  }

  // RENDER-D42: a bare DOMContentLoaded listener never fires if this script
  // is loaded after DOM parsing has already finished — a defer/async
  // attribute added by an optimisation plugin, a "defer JS" caching-layer
  // setting, or a dynamic re-injection — leaving the calendar, gallery and
  // lightbox permanently inert with no error. Same guard email-modal.js
  // already uses.
  function ready(fn){
    if(document.readyState !== 'loading'){ fn(); }
    else { document.addEventListener('DOMContentLoaded', fn); }
  }

  // Task 42's group-parent roster tabs used to be collapsed/switched by a
  // small initRosterTabs() here (toggling `hidden`, then a full APG
  // roving-tabindex keydown handler once review found the keyboard trap that
  // left). CodeRabbit review: every tab is now a real `<a href="...
  // &occurrence=<child>">` — switching tabs is a full page load rendered
  // server-side (Roster::render_frontend_group()), so there is nothing left
  // for JS to do here; the no-JS and JS experiences are now the same thing.

  ready(function(){
    initCalendars();
    initGalleries();
    initLightbox();
  });

  // Lightbox
  var lb = { el: null, img: null, caption: null, counter: null, items: [], index: 0, group: null };

  function buildLightbox(){
    if(lb.el){ return; }
    var el = document.createElement('div');
    el.className = 'anchor-event-lightbox';
    el.setAttribute('aria-hidden', 'true');
    el.innerHTML = ''
      + '<div class="anchor-event-lightbox-backdrop"></div>'
      + '<button type="button" class="anchor-event-lightbox-close" aria-label="Close">&times;</button>'
      + '<button type="button" class="anchor-event-lightbox-nav anchor-event-lightbox-prev" aria-label="Previous">&larr;</button>'
      + '<button type="button" class="anchor-event-lightbox-nav anchor-event-lightbox-next" aria-label="Next">&rarr;</button>'
      + '<figure class="anchor-event-lightbox-stage">'
      +   '<img class="anchor-event-lightbox-image" alt="" />'
      +   '<figcaption class="anchor-event-lightbox-caption"></figcaption>'
      + '</figure>'
      + '<div class="anchor-event-lightbox-counter"></div>';
    document.body.appendChild(el);
    lb.el = el;
    lb.img = el.querySelector('.anchor-event-lightbox-image');
    lb.caption = el.querySelector('.anchor-event-lightbox-caption');
    lb.counter = el.querySelector('.anchor-event-lightbox-counter');

    el.querySelector('.anchor-event-lightbox-backdrop').addEventListener('click', closeLightbox);
    el.querySelector('.anchor-event-lightbox-close').addEventListener('click', closeLightbox);
    el.querySelector('.anchor-event-lightbox-prev').addEventListener('click', function(){ navLightbox(-1); });
    el.querySelector('.anchor-event-lightbox-next').addEventListener('click', function(){ navLightbox(1); });
    document.addEventListener('keydown', function(e){
      if(!lb.el || !lb.el.classList.contains('is-open')){ return; }
      if(e.key === 'Escape'){ closeLightbox(); }
      else if(e.key === 'ArrowLeft'){ navLightbox(-1); }
      else if(e.key === 'ArrowRight'){ navLightbox(1); }
    });
  }

  function openLightbox(items, index){
    buildLightbox();
    lb.items = items;
    lb.index = index;
    showLightboxItem();
    lb.el.classList.add('is-open');
    lb.el.setAttribute('aria-hidden', 'false');
    document.body.classList.add('anchor-event-lightbox-open');
  }

  function closeLightbox(){
    if(!lb.el){ return; }
    lb.el.classList.remove('is-open');
    lb.el.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('anchor-event-lightbox-open');
    lb.img.removeAttribute('src');
  }

  function navLightbox(dir){
    if(!lb.items.length){ return; }
    lb.index = (lb.index + dir + lb.items.length) % lb.items.length;
    showLightboxItem();
  }

  function showLightboxItem(){
    var item = lb.items[lb.index];
    if(!item){ return; }
    lb.img.style.opacity = '0';
    var preload = new Image();
    // CodeRabbit finding-8 (PR #20, 2nd round): onload/onerror fire
    // asynchronously — navigating again (navLightbox()) before a preload
    // resolves left its callback still armed, and it fired later against
    // whatever item had since become current, blanking or corrupting a
    // newer image with a stale one's src/caption. Bail out of both
    // callbacks once lb.index no longer points at the item THIS preload
    // was for.
    preload.onload = function(){
      if(lb.items[lb.index] !== item){ return; }
      lb.img.src = item.src;
      lb.img.alt = item.caption || '';
      lb.img.style.opacity = '1';
    };
    // RENDER-D26: with no onerror, a missing/blocked attachment left the
    // lightbox open with an invisible image forever (opacity stayed 0 —
    // only onload restored it) and no way to tell "loading" from "broken".
    preload.onerror = function(){
      if(lb.items[lb.index] !== item){ return; }
      lb.img.removeAttribute('src');
      lb.img.alt = '';
      lb.img.style.opacity = '1';
      lb.caption.textContent = 'This image could not be loaded.';
      lb.caption.style.display = '';
    };
    preload.src = item.src;
    lb.caption.textContent = item.caption || '';
    lb.caption.style.display = item.caption ? '' : 'none';
    if(lb.items.length > 1){
      lb.counter.textContent = (lb.index + 1) + ' / ' + lb.items.length;
      lb.counter.style.display = '';
    } else {
      lb.counter.style.display = 'none';
    }
    var multi = lb.items.length > 1;
    lb.el.querySelector('.anchor-event-lightbox-prev').style.display = multi ? '' : 'none';
    lb.el.querySelector('.anchor-event-lightbox-next').style.display = multi ? '' : 'none';
  }

  function initLightbox(){
    document.querySelectorAll('.anchor-event-gallery').forEach(function(gallery){
      if(gallery.dataset.anchorLightboxBound){ return; }
      gallery.dataset.anchorLightboxBound = '1';
      gallery.addEventListener('click', function(e){
        var slide = e.target.closest('a[data-anchor-lightbox]');
        if(!slide || !gallery.contains(slide)){ return; }
        e.preventDefault();
        var slides = Array.prototype.slice.call(gallery.querySelectorAll('a[data-anchor-lightbox]'));
        var items = slides.map(function(s){
          return { src: s.getAttribute('href'), caption: s.getAttribute('data-caption') || '' };
        });
        var index = slides.indexOf(slide);
        if(index < 0){ index = 0; }
        openLightbox(items, index);
      });
    });
  }

  // Tooltip logic
  var tooltip, activeLink = null;
  function ensureTooltip(){
    if(tooltip) return tooltip;
    tooltip = document.createElement('div');
    tooltip.className = 'anchor-event-tooltip';
    tooltip.innerHTML = '<img alt=\"\" /><div class=\"anchor-event-tooltip-title\"></div>';
    document.body.appendChild(tooltip);
    return tooltip;
  }

  function handleTooltipOver(e){
    var link = e.target.closest('.anchor-event-calendar-link');
    if(!link) return;
    if(activeLink === link){ return; }
    activeLink = link;
    var tip = ensureTooltip();
    var title = link.dataset.title || link.textContent || '';
    var thumb = link.dataset.thumb || '';
    tip.querySelector('.anchor-event-tooltip-title').textContent = title;
    var img = tip.querySelector('img');
    if(thumb){
      img.src = thumb;
      img.style.display = '';
    } else {
      img.removeAttribute('src');
      img.style.display = 'none';
    }
    tip.classList.add('is-visible');
  }

  function handleTooltipMove(e){
    if(!tooltip || !tooltip.classList.contains('is-visible')) return;
    var x = e.clientX + 12;
    var y = e.clientY + 12;
    tooltip.style.left = x + 'px';
    tooltip.style.top = y + 'px';
  }

  function handleTooltipOut(e){
    var link = e.target.closest('.anchor-event-calendar-link');
    if(!link) return;
    // If moving within the same link, ignore
    if(e.relatedTarget && link.contains(e.relatedTarget)){ return; }
    if(tooltip){
      tooltip.classList.remove('is-visible');
    }
    activeLink = null;
  }
})();
